import { RRPP } from "../user";
import { Request } from "./request.model";

export class RRPPRequest {
  id: number;
  request: Request;
  rrpp: RRPP;
}
